import React from 'react';
import { useVoice } from '../contexts/VoiceContext';
import { useApp } from '../contexts/AppContext';
import { Signal, PhoneOff, Settings } from 'lucide-react';

export const VoicePanel = () => {
  const { voiceChannel, leaveVoice } = useVoice();
  const { channels } = useApp();

  if (!voiceChannel) return null;

  const channel = channels.find(c => c.channel_id === voiceChannel);

  return (
    <div className="bg-[#1a1d23] border-t border-white/5 px-3 py-2" data-testid="voice-panel">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 min-w-0">
          <div className="h-8 w-8 rounded-md bg-green-500/10 flex items-center justify-center">
            <Signal className="h-4 w-4 text-green-400 flex-shrink-0" />
          </div>
          <div className="min-w-0">
            <p className="text-xs font-semibold text-green-400">Voce conectată</p>
            <p className="text-[10px] text-zinc-500 truncate">{channel?.name || 'Voice Channel'}</p>
          </div>
        </div>
        <div className="flex items-center gap-1">
          <button
            data-testid="voice-panel-settings-btn"
            className="p-1.5 rounded-md text-zinc-400 hover:text-white hover:bg-white/10 transition-colors"
            title="Setări voce"
          >
            <Settings className="h-4 w-4" />
          </button>
          <button onClick={leaveVoice} data-testid="voice-panel-disconnect-btn"
            className="p-1.5 rounded-md text-zinc-400 hover:text-red-400 hover:bg-red-500/10 transition-colors"
            title="Disconnect">
            <PhoneOff className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
};
